// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.center-spinner {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
}
#split-component {
  height: 100%;
}
#split-component .left-side {
  width: 100%;
  background-color: var(--primary-color);
}
#split-component .left-side .partner-powered {
  margin-bottom: 0.8rem;
}
@media (max-width: 768px) {
  #split-component .left-side .partner-powered {
    transform: none;
  }
}
#split-component .left-side .gyra-logo-background {
  position: absolute;
  max-height: 100vh;
  top: 0;
  right: 0;
}
@media (max-width: 768px) {
  #split-component .left-side .gyra-logo-background {
    max-width: 100vw;
    position: absolute;
    top: 0;
    left: 0;
  }
}
#split-component .left-side .left-side-row {
  width: 100%;
  height: 100%;
}
#split-component .left-side .left-side-col {
  display: flex !important;
  flex-direction: column !important;
  width: 100%;
}
#split-component .left-side .left-side-wrapper {
  height: 100%;
  padding: 25px;
  display: flex;
  flex-direction: column;
}
#split-component .left-side .logo-container {
  width: 140px;
}
#split-component .left-side .logo-container .gyra-logo {
  width: 100%;
}
#split-component .left-side .partner-logo-wrapper {
  margin: auto;
}
#split-component .left-side .partner-logo {
  width: 400px;
}
@media (max-width: 768px) {
  #split-component .left-side .partner-logo {
    position: absolute;
    bottom: 1.4rem;
    width: 70%;
    left: 22px;
  }
}
#split-component .right-side {
  display: flex;
  flex-direction: column;
  height: 100vh;
  justify-content: center;
  align-items: center;
  background-color: white;
}
#split-component .right-side .copyright {
  position: absolute;
  bottom: 4rem;
  color: #C9D3CC;
  font-size: 0.95rem;
}
@media (max-width: 992px) {
  #split-component .left-side {
    height: 0;
  }
}
@media (max-width: 768px) {
  #split-component {
    display: inline;
  }
  #split-component .left-side {
    width: 100vw;
    height: 36vh;
    display: flex;
  }
  #split-component .left-side .logo-container {
    width: 120px;
    margin: 1.4rem 0 0 1.4rem;
  }
  #split-component .right-side {
    height: auto;
    width: 100vw;
  }
  #split-component .right-side .copyright {
    position: initial;
    bottom: 2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/others/LogInScreenWrapper/styles.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;AACF;AAEA;EACC,YAAA;AAAD;AADA;EAIE,WAAA;EACA,sCAAA;AAAF;AALA;EAQG,qBAAA;AAAH;AAEG;EAAA;IACC,eAAA;EACF;AACF;AAbA;EAgBM,kBAAA;EACH,iBAAA;EACA,MAAA;EACA,QAAA;AAAH;AAEM;EAAA;IACE,gBAAA;IACA,kBAAA;IACA,MAAA;IACA,OAAA;EACN;AACF;AA3BA;EA8BM,WAAA;EACA,YAAA;AAAN;AA/BA;EAmCM,wBAAA;EACA,iCAAA;EACA,WAAA;AADN;AApCA;EAyCM,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;AAFN;AA1CA;EAgDG,YAAA;AAHH;AA7CA;EAkDI,WAAA;AAFJ;AAhDA;EAuDM,YAAA;AAJN;AAnDA;EA2DM,YAAA;AALN;AAOM;EAAA;IACE,kBAAA;IACA,cAAA;IACA,UAAA;IACA,UAAA;EAJN;AACF;AA9DA;EAuEE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;AANF;AAtEA;EA+EG,kBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;AANH;AAUC;EAAA;IAEE,SAAA;EARD;AACF;AAWC;EAAA;IACC,eAAA;EARA;EAOD;IAIE,YAAA;IACA,YAAA;IACA,aAAA;EARD;EAED;IASG,YAAA;IACA,yBAAA;EARF;EAFD;IAeE,YAAA;IACA,YAAA;EAVD;EAND;IAmBG,iBAAA;IACA,YAAA;EAVF;AACF","sourcesContent":[".center-spinner {\n  display: flex;\n  height: 100%;\n  align-items: center;\n  justify-content: center;\n}\n\n#split-component {\n\theight: 100%;\n\n\t.left-side {\n\t\twidth: 100%;\n\t\tbackground-color: var(--primary-color);\n\n\t\t.partner-powered {\n\t\t\tmargin-bottom: .8rem;\n\n\t\t\t@media(max-width: @md-screen) {\n\t\t\t\ttransform: none;\n\t\t\t}\n\t\t}\n\n    .gyra-logo-background {\n      position: absolute;\n\t\t\tmax-height: 100vh;\n\t\t\ttop: 0;\n\t\t\tright: 0;\n\n      @media(max-width: @md-screen) {\n        max-width: 100vw;\n        position: absolute;\n        top: 0;\n        left: 0;\n      }\n    }\n\n    .left-side-row {\n      width: 100%;\n      height: 100%;\n    }\n\n    .left-side-col {\n      display: flex !important;\n      flex-direction: column !important;\n      width: 100%;\n    }\n\n    .left-side-wrapper {\n      height: 100%;\n      padding: 25px;\n      display: flex;\n      flex-direction: column;\n    }\n\n\t\t.logo-container {\n\t\t\twidth: 140px;\n\t\t\t.gyra-logo {\n\t\t\t\twidth: 100%;\n\t\t\t}\n\t\t}\n\n    .partner-logo-wrapper {\n      margin: auto;\n    }\n\n    .partner-logo {\n      width: 400px;\n\n      @media(max-width: @md-screen) {\n        position: absolute;\n        bottom: 1.4rem;\n        width: 70%;\n        left: 22px;\n      }\n    }\n\t}\n\n\t.right-side {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\theight: 100vh;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tbackground-color: white;\n\n\t\t.copyright {\n\t\t\tposition: absolute;\n\t\t\tbottom: 4rem;\n\t\t\tcolor: #C9D3CC;\n\t\t\tfont-size: .95rem;\n\t\t}\n\t}  \n\t\n\t@media(max-width: @lg-screen) {\n\t\t.left-side {\n\t\t\theight: 0;\n\t\t}\n\t}\n\n\t@media(max-width: @md-screen) {\n\t\tdisplay: inline;\n\t\t\n\t\t.left-side {\n\t\t\twidth: 100vw;\n\t\t\theight: 36vh;\n\t\t\tdisplay: flex;\n\n\t\t\t.logo-container {\n\t\t\t\twidth: 120px;\n\t\t\t\tmargin: 1.4rem 0 0 1.4rem;\n\t\t\t}\n\t\t}\n\n\t\t.right-side {\n\t\t\theight: auto;\n\t\t\twidth: 100vw;\n\n\t\t\t.copyright {\n\t\t\t\tposition: initial;\n\t\t\t\tbottom: 2rem;\n\t\t\t}\n\t\t}\n\t\t\n\t}\n}\n@xs-screen: 480px;@sm-screen: 576px;@md-screen: 768px;@lg-screen: 992px;@xl-screen: 1200px;@xxl-screen: 1600px;@content-max-width: 1598px;@border-radius: 1.25rem;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
